import { config as CONFIG } from '@platform/api'

/**
 *
 * @param element 元素
 * @return boolean
 */
export function stopEnterHotKey(element) {
    return element.className &&
		element.className.includes(CONFIG.stopEnterHotKey);
}
